import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { AccountDeletionsPage } from '@/pages/AccountDeletionsPage';
import { DeletionArchivePage } from '@/pages/DeletionArchivePage';
import { Layout } from '@/components/Layout';
import { DashboardPage } from '@/pages/DashboardPage';
import { LoginPage } from '@/pages/LoginPage';
import { ConsultationsListPage } from '@/pages/ConsultationsListPage';
import { ConsultationDetailPage } from '@/pages/ConsultationDetailPage';
import { OrdersListPage } from '@/pages/OrdersListPage';
import { OrderDetailPage } from '@/pages/OrderDetailPage';
import { ProductsListPage } from '@/pages/ProductsListPage';
import { ProductDetailPage } from '@/pages/ProductDetailPage';
import { SettlementsPage } from '@/pages/SettlementsPage';
import { FailedPayoutsPage } from '@/pages/FailedPayoutsPage';
import { RefundsPage } from '@/pages/RefundsPage';
import { ActionNeededPage } from '@/pages/ActionNeededPage';
import { VtuPage } from '@/pages/VtuPage';
import { FeesPage } from '@/pages/FeesPage';
import { TermsPage } from '@/pages/TermsPage';
import { UsersListPage } from '@/pages/UsersListPage';
import { UserDetailPage } from '@/pages/UserDetailPage';
import { BroadcastSegmentsPage } from '@/pages/BroadcastSegmentsPage';
import { TeamPage } from '@/pages/TeamPage';
import { AcceptInvitePage } from '@/pages/AcceptInvitePage';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* Public — the invitee has no session until they set a password. */}
          <Route path="/accept-invite" element={<AcceptInvitePage />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/users" element={<UsersListPage />} />
            <Route path="/users/:id" element={<UserDetailPage />} />
            <Route
              path="/broadcast-segments"
              element={<BroadcastSegmentsPage />}
            />
            <Route path="/products" element={<ProductsListPage />} />
            <Route path="/products/:id" element={<ProductDetailPage />} />
            <Route path="/orders" element={<OrdersListPage />} />
            <Route path="/orders/:reference" element={<OrderDetailPage />} />
            <Route path="/consultations" element={<ConsultationsListPage />} />
            <Route
              path="/consultations/:id"
              element={<ConsultationDetailPage />}
            />
            <Route path="/settlements" element={<SettlementsPage />} />
            <Route path="/settlements/failed" element={<FailedPayoutsPage />} />
            <Route path="/refunds" element={<RefundsPage />} />
            <Route path="/action-needed" element={<ActionNeededPage />} />
            <Route path="/vtu" element={<VtuPage />} />
            <Route path="/fees" element={<FeesPage />} />
            <Route
              path="/account-deletions"
              element={<AccountDeletionsPage />}
            />
            <Route
              path="/account-deletions/archive"
              element={<DeletionArchivePage />}
            />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/team" element={<TeamPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
